import * as React from 'react';
import { Component } from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import {
    DataStore,
    DisclaimerStore,
    EntityStore,
    SuperscriptScope,
} from '../stores';
import FundFactItem from './FundFactItem';
import Disclaimers from './Disclaimers';
import HTag from './HTag';
import { IQueryContext } from '@kurtosys/ksys-app-template/dist/models/query';
import { FundFacts as FundFactsConfig } from '../models/configuration/components/FundFacts';
import { Card } from '../models/configuration/components/Card';

const FundFactsWrapper = styled<any, any>(
    'div',
    'fundFactsWrapper',
    'fundFacts'
)`
    ${propStyles};
`;

FundFactsWrapper.defaultProps = {};

const FundFactsList = styled<any, any>('ul', 'fundFactsList', 'fundFacts')`
    ${propStyles};
    list-style: none;
`;

FundFactsList.defaultProps = {
    display: 'flex',
    flexWrap: 'wrap',
    marginY: 'md',
};

interface FundFactProps {
    // Injected via withColumns
    dataStore?: DataStore;
    entityStore?: EntityStore;
    queryContext?: IQueryContext;
    cards?: Array<Card>;
    // TODO: check whether this property is deprecated and can possibly be removed
    rows?: Array<any>;
    disclaimers?: Array<string>;
    /** */
    theme?: { [key: string]: React.CSSProperties };
    showHeading?: boolean;
    fundFacts?: FundFactsConfig;
}

@observer
class FundFacts extends Component<FundFactProps, any> {
    @computed
    get dataStore(): DataStore {
        const { dataStore } = this.props;
        return dataStore;
    }

    @computed
    get disclaimerStore(): DisclaimerStore {
        if (this.dataStore) {
            return this.dataStore.stores.disclaimer;
        }
    }

    render() {
        const {
            entityStore,
            theme,
            showHeading,
            fundFacts,
            cards,
            rows,
            disclaimers,
            queryContext,
        } = this.props;
        const { multipleValueLayout = 'column' } = fundFacts;
        return (
            <FundFactsWrapper {...theme.FundFactsWrapper}>
                {showHeading && (
                    <HTag
                        componentTheme={'FundFactsHeading'}
                        defaultStyleProps={{
                            color: 'body',
                            fontFamily: 'heading',
                            fontWeight: 'bold',
                            fontSize: 'md',
                        }}
                        level={2}
                        text={fundFacts.label}
                    />
                )}
                <FundFactsList {...theme.FundFactCardsList}>
                    {cards.map((card, index) => (
                        <FundFactItem
                            key={`${card.label}-${index}`}
                            card={card}
                            theme={{
                                ...theme,
                                FundFactItem: theme.FundFactCardListItem,
                                FundFact: theme.FundFactCard,
                                FundFactHeading: theme.FundFactCardHeading,
                                FundFactAsAtDate: theme.FundFactCardAsAtDate,
                                FundFactValue: theme.FundFactCardValue,
                            }}
                            multipleValueLayout={multipleValueLayout}
                        />
                    ))}
                </FundFactsList>
                <FundFactsList {...theme.FundFactRowsList}>
                    {rows.map((card, index) => (
                        <FundFactItem
                            key={`${card.label}-${index}`}
                            card={card}
                            theme={{
                                ...theme,
                                FundFactItem: {
                                    flex: ['1 0 100%', '0 1 50%'],
                                    minHeight: '0',
                                    ...theme.FundFactRowListItem,
                                },
                                FundFact: {
                                    flexDirection: 'row',
                                    boxShadow: 'none',
                                    borderStyle: 'none none solid none',
                                    borderRadius: '0',
                                    padding: 'sm',
                                    ...theme.FundFactRow,
                                },
                                FundFactHeading: {
                                    fontSize: 'sm',
                                    flex: '1 1 auto',
                                    textAlign: 'left',
                                    margin: '0',
                                    ...theme.FundFactRowHeading,
                                },
                                FundFactAsAtDate: theme.FundFactRowAsAtDate,
                                FundFactValue: {
                                    flex: '1 1 50%',
                                    fontSize: 'sm',
                                    color: 'body',
                                    textAlign: 'right',
                                    justifyContent: 'flex-end',
                                    ...theme.FundFactRowValue,
                                },
                            }}
                            multipleValueLayout={multipleValueLayout}
                        />
                    ))}
                </FundFactsList>

                {this.disclaimerStore && (
                    <Disclaimers
                        disclaimers={this.disclaimerStore.getDisclaimersForDisplay(
                            [],
                            true,
                            SuperscriptScope.fundCard,
                            queryContext
                        )}
                        superscriptContext={entityStore.value.clientCode}
                        theme={{
                            ...theme,
                            DisclaimersList:
                                theme.FundFactsFootnotedDisclaimersList,
                            DisclaimerListItem:
                                theme.FundFactsFootnotedDisclaimerListItem,
                            DisclaimerCharacter:
                                theme.FundFactsFootnotedDisclaimerCharacter,
                            DisclaimerContent:
                                theme.FundFactsFootnotedDisclaimerContent,
                            DisclaimerReturnLink:
                                theme.FundFactsFootnotedDisclaimerReturnLink,
                        }}
                    />
                )}

                <Disclaimers
                    disclaimers={disclaimers}
                    theme={{
                        ...theme,
                        DisclaimersList: theme.FundFactsDisclaimersList,
                        DisclaimerListItem: theme.FundFactsDisclaimerListItem,
                        DisclaimerCharacter: theme.FundFactsDisclaimerCharacter,
                        DisclaimerContent: theme.FundFactsDisclaimerContent,
                        DisclaimerReturnLink:
                            theme.FundFactsDisclaimerReturnLink,
                    }}
                />
            </FundFactsWrapper>
        );
    }
}

export default withTheme(FundFacts) as any;



// WEBPACK FOOTER //
// ./src/Components/FundFacts.tsx